import React, { Suspense, useState, useEffect } from "react";
import { Modal } from 'react-responsive-modal';
import ClientProfileSevices from "../clientProfileServices";
import UserService from "../../User/UserService";
import { CommonUtilities } from "../../../commonUtils";

export default function UserProfile() {

    let [newPswd, setChangeNewPswd] = useState("");
    let [oldPswd, setChangeOldPswd] = useState("");
    let [alert, setAlert] = useState(false);
    let [openFirst, setOpenFirst] = useState(false);
    let [changePswd, setChangePswd] = useState(false);
    let [Blankfield, setBlankfield] = useState(false);
    let [saveSucess, setSaveSucess] = useState(false);
    let [confirmPswd, setChangeConfirmPswd] = useState("");
    let [selectedFile, setSelectedFile] = useState<File | null>(null);
    let [userDetail, setUserDetail] = useState<any>({
        avatar: "", avatarTh: "", email: "",
        firstName: "", lastName: "", userId: "",
    });

    useEffect(() => {

        console.log(selectedFile)
        if (openFirst) {
            userDetail = {};
            console.log(window.sessionStorage.getItem('loggedUserRight'));

            if (userDetail) {
                try {
                    const user_Detail = JSON.parse(window.sessionStorage.getItem('loggedUserRight') || '');

                    userDetail.avatar = user_Detail?.avatar ? user_Detail.avatar : "../Resources/Images/nocontact.jpg";
                    userDetail.avatarTh = user_Detail?.avatarTh ? user_Detail.avatarTh : "../Resources/Images/nocontact.jpg";
                    userDetail.email = user_Detail?.email;
                    userDetail.firstName = user_Detail?.firstName;
                    userDetail.lastName = user_Detail?.lastName;
                    userDetail.userId = user_Detail?.userId;

                    setUserDetail(userDetail);
                } catch (e) {
                    console.error("Invalid JSON in sessionStorage for 'loggedUserRight'", e);
                }
            }

            console.log(userDetail);
        }

    }, [openFirst])

    const onPasswordEdit = () => {
        console.log("onPasswordEdit")
        console.log(confirmPswd)
        console.log(newPswd)

        if (oldPswd.length === 0 || newPswd.length === 0 || confirmPswd.length === 0) {
            Blankfield = true;
            setBlankfield(Blankfield)
        }

        if (confirmPswd !== newPswd) {
            alert = true;
            setAlert(Blankfield)
        }


        if (!alert && !Blankfield) {
            var payload = {
                email: userDetail?.email,
                newPassword: newPswd,
                oldPassword: oldPswd
            }
            ClientProfileSevices.changePassword(payload).then((value: any) => {

                if (value?.result === true) {
                    saveSucess = value?.result;
                    setSaveSucess(saveSucess);
                }
            })
        }

        setTimeout(function () {
            setBlankfield(false);
            setAlert(false);
            setSaveSucess(false);
        }, 3000);

    }

    const handleFileChange = (event: any) => {

        const fileName = event.target.files[0];
        console.log(fileName);

        if (fileName) {
            userDetail.avatarTh = URL.createObjectURL(fileName)
            setSelectedFile(fileName); // sets the first file
        }

    };

    const handleUpload = () => {

        // Code to upload selectedFile to the server
        var data = { 'userId': userDetail.userId, 'avatar': '', 'avatarTh': '' }
        console.log(data);
        console.log(selectedFile);
        UserService.postUploadFile(selectedFile, data).then((res) => {
            CommonUtilities.setAvatar(res);
        })
    };


    return (

        <div className="pull-left">

            <div className="box-primary text-center iconLogo pull-right" onClick={() => setOpenFirst(true)}>
                <div className="ws-12">
                    <i className="box pm icon-user-solid-circle"></i>
                    User Profile
                </div>
            </div>

            <Modal open={openFirst} onClose={() => { setOpenFirst(false); setChangePswd(false) }} center>

                <div className="box">
                    <div className="box-header-main">
                        <h2 className="text-l">User Info</h2>
                    </div>

                    <div className="box-content">

                        {Blankfield && <div className="alert alert-danger">There was a problem submitting your request, one or more fields are missing or incorrect.</div>}

                        {alert && <div className="alert alert-warning mt">New Password does not match Confirm Password</div>}

                        {saveSucess && <span>Your password has been updated successfully</span>}


                        <div className="ws-3">
                            <div className="creatorImg pm pull-left">

                                <div className="box shadowCoverPicture shadow">
                                    <div className="coverPicture">
                                        <img alt="Korrect"  className="ws-12" src={userDetail?.avatarTh} ng-if="!contactInfo.creatorImage" />
                                    </div>

                                </div>
                            </div>

                            <div className="mll ws-10">
                                <label className="icon-btn primary btn-m" >
                                    <input type="file" accept="image/*" className="hide" onChange={handleFileChange} /> Select Image
                                </label>

                                <button className="icon-btn edit btn-m" disabled={selectedFile === null} onClick={() => handleUpload()}>Save Image</button>

                            </div>


                        </div>

                        <div className="ws-5">

                            <div className="control-group pm ws-10">
                                <span className="control-label ws-4 pull-left text-l">First Name</span>
                                <input className="ws-8 pull-left" type="text" id="userFirst" ng-model="loginResponse.firstName" value={userDetail?.firstName} readOnly />
                            </div>

                            <div className="control-group  pm ws-10">
                                <span className="control-label ws-4 pull-left text-l">Last Name</span>
                                <input className="ws-8 pull-left" type="text" id="userLast" ng-model="loginResponse.lastName" value={userDetail?.lastName} readOnly />
                            </div>

                            <div className="control-group  pm ws-10">
                                <span className="control-label ws-4 pull-left text-l">Email Address</span>
                                <input className="ws-8 pull-left" type="text" id="userEmail" ng-model="loginResponse.email" value={userDetail?.email} readOnly />
                            </div>

                            <div className='control-group  pm ws-10'>
                                <label className="switch mr pull-right">
                                    <input type="checkbox" checked={changePswd} onChange={() => setChangePswd(!changePswd)} />
                                    {changePswd && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!changePswd && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                                <span className='text-bold text-left mb pull-right mrl text-m'>Change Password</span>
                            </div>

                            {changePswd && <>

                                <div className="control-group pm ws-10">
                                    <span className="control-label ws-4 pull-left text-l">Old Password</span>
                                    <input className="ws-8 pull-left" value={oldPswd} type="password" name="OldPassword" placeholder="Enter Old Password" id="OldPassword"
                                        onChange={(e: any) => setChangeOldPswd(e.target.value)} required />
                                </div>

                                <div className="control-group  pm ws-10">
                                    <span className="control-label ws-4 pull-left text-l">New Password</span>
                                    <input className="ws-8 pull-left" value={newPswd} type="password" name="Password" placeholder="Enter New Password" id="Password"
                                        onChange={(e: any) => setChangeNewPswd(e.target.value)} ng-minlength="8" ng-pattern="/(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])/" required={true} />

                                </div>

                                <div className="control-group pm ws-10">
                                    <span className="control-label ws-4 pull-left text-l">Confirm Password</span>
                                    <input className="ws-8 pull-left" value={confirmPswd} type="password" name="confirmPassword" placeholder="Confirm Password" id="confirmPassword"
                                        onChange={(e: any) => setChangeConfirmPswd(e.target.value)} ng-minlength="8" ng-pattern="/(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])/" required={true} />

                                </div>

                            </>}

                        </div>
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete" value="Close" onClick={() => { setOpenFirst(false); setChangePswd(false) }}>Close </button>
                        {changePswd && <button type="button" className="icon-btn info" onClick={onPasswordEdit}>Change Password </button>}
                    </div>
                </div>

            </Modal>
        </div>

    )
}